module.exports = __webpack_public_path__ + "static/media/CircleArrowRight.1cd50ceb.svg";